/**
 * ChapterProgressBar
 *
 * Thin horizontal indicator rendered beneath the chapter title for any
 * chapter whose stored play-state is a positive integer (in-progress).
 *
 * Filled width is `min(1, resumeSeconds / durationSeconds) * 100%`,
 * inlined as a percentage so the SC-011 contract test can assert the
 * computed value to within ±1% (Tailwind's static fraction utilities
 * cannot express the continuous ratio).
 *
 * Per FR-013, the component renders nothing when:
 * - `durationSeconds` is missing, `<= 0`, or non-numeric
 * - `resumeSeconds` is missing, `<= 0`, or non-numeric
 *
 * The element is purely decorative — no ARIA role is exposed.
 */

function isPositiveNumber(value) {
  return typeof value === 'number' && Number.isFinite(value) && value > 0;
}

function ChapterProgressBar({ resumeSeconds, durationSeconds }) {
  if (!isPositiveNumber(resumeSeconds) || !isPositiveNumber(durationSeconds)) {
    return null;
  }

  const ratio = Math.min(1, resumeSeconds / durationSeconds);
  const widthPct = `${ratio * 100}%`;

  return (
    <div
      data-testid="chapter-progress-bar"
      className="mt-1 h-1 w-full overflow-hidden rounded-full bg-gray-200 dark:bg-gray-700"
    >
      <div
        data-testid="chapter-progress-bar-fill"
        className="h-full bg-primary"
        style={{ width: widthPct }}
      />
    </div>
  );
}

export default ChapterProgressBar;
